import Vue from 'vue'
import { JobOfferResponse, JobOfferResponseProps, JobOfferResponseState, JobReview } from '@dinosband/bv-main-schema/dist/types'

import { SubscriptionManager, JobOfferResponseSubscriber } from '../..'
import { DataCenter_ProxyType } from '../abstract'
import { JOB_REVIEW_ADDED, JOB_OFFER_RESPONSE_UPDATED } from './const'

export class MyJobOfferResponses extends DataCenter_ProxyType<number, JobOfferResponse> { // <jobOfferId, JobOfferResponse>

  responses: Record<number, JobOfferResponse[]> = {} // <jobOfferId: JobOfferResponse[]>
  _subscriber!: JobOfferResponseSubscriber
  _subscriptions = new SubscriptionManager()

  async init () {
    this._subscriber = new JobOfferResponseSubscriber({ mainStore: this.mainStore }, (value) => {
      this.onJobOfferResponseUpdated(value)
    })
    await this._subscriber.start()
    this._subscriptions.init(this.pubsub)
    this._subscriptions.subscribe(JOB_REVIEW_ADDED, (value: JobReview) => this.onJobReviewAdded(value))
    await this.retrieve()
  }

  cleanup () {
    this.responses = {}
    super.cleanup()
    this._subscriptions.cleanup()
    this._subscriber?.cleanup()
  }

  getAll (jobOfferId: number) {
    return this.responses[jobOfferId] ?? []
  }

  async updateJobOfferResponseProps (jobOfferResponseId: number, props: JobOfferResponseProps): Promise<JobOfferResponse | undefined> {
    return await this.mainStore.updateJobOfferResponseProps(jobOfferResponseId, props)
  }

  async updateJobOfferResponseState (responseId: number, messageId: number, state: JobOfferResponseState) {
    return await this.mainStore.updateJobOfferResponseState(responseId, messageId, state)
  }

  onReconnected () {
    this.retrieve()
  }

  async retrieve () {
    if (!this.mainStore.userId) {
      return
    }
    const results = await this.mainStore.readMyJobOfferResponses({})
    results.forEach((i) => this.onJobOfferResponseUpdated(i))
  }

  protected async query (jobOfferId: number): Promise<JobOfferResponse | undefined> {
    const result = await this.mainStore.readJobOfferResponsesOfJobOffer(jobOfferId) ?? []
    Vue.set(this.responses, jobOfferId, result)
    return result[0]
  }

  private onJobOfferResponseUpdated (value: JobOfferResponse) {
    if (value.providerUserId !== this.mainStore.userId) {
      return
    }
    this._updateValue(value)
  }

  private onJobReviewAdded (value: JobReview) {
    const chatRoomId = value.chatRoomId
    const response = this.values.find((i) => i.chatRoomId === chatRoomId) ??
                     Object.values(this.responses).flatMap((i) => i).find((i) => i.chatRoomId === chatRoomId)
    if (!response) {
      return
    }
    if (response.id === value.jobAsClientId) {
      response.reviewByClient = value
    } else if (response.id === value.jobAsProviderId) {
      response.reviewByProvider = value
    }
    this._updateValue(response)
  }

  private _updateValue (value: JobOfferResponse) {
    const objs = this.responses[value.jobOfferId] ?? []
    const idx = objs.findIndex((i) => i.id === value.id) ?? 0
    objs[idx] = value
    Vue.set(this.responses, value.jobOfferId, objs)
    this.set(value.jobOfferId, value)
    this.pubsub.publish(JOB_OFFER_RESPONSE_UPDATED, value)
  }

}